import { useState, useEffect } from 'react';
import { Form } from 'antd';
import { fetchAuthorsList, createAuthor, updateAuthor } from '../../Services/CourseListService';
import { toast } from 'react-toastify';

export const useAuthors = () => {
  const [form] = Form.useForm();
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingAuthor, setEditingAuthor] = useState(null);
  const [pagination, setPagination] = useState({
  currentPage: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  orderByLatest: true
});


  // Load authors on component mount
useEffect(() => {
  loadAuthors();
}, [
  pagination.currentPage,
  pagination.pageSize,
  pagination.orderByLatest
]);


  const loadAuthors = async () => {
  setLoading(true);
  try {
    const data = await fetchAuthorsList({
      pageNumber: pagination.currentPage,
      pageSize: pagination.pageSize,
      orderByLatest: pagination.orderByLatest
    });

    setAuthors(Array.isArray(data.items) ? data.items : []);

    setPagination(prev => ({
      ...prev,
      totalCount: data.totalCount ?? 0,
      totalPages: data.totalPages ?? 0
    }));

    setError(null);
  } catch (err) {
    setError(err.message || 'Failed to load authors');
    setAuthors([]);
  } finally {
    setLoading(false);
  }
};

const handlePageChange = (page, pageSize) => {
  setPagination(prev => ({
    ...prev,
    currentPage: page,
    pageSize
  }));
};


  const handleAddNew = () => {
    setEditingAuthor(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (author) => {
    setEditingAuthor(author);
    form.setFieldsValue({
      name: author.name,
      email: author.email,
      linkedInProfile: author.linkedInProfile,
      bio: author.bio || ""
    });
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
  try {
    const authorData = {
      name: values.name.trim(),
      email: values.email.trim(),
      linkedInProfile: values.linkedInProfile.trim(),
      bio: values.bio ? values.bio.trim() : ""
    };

    if (editingAuthor) {
      await updateAuthor({
        ...authorData,
        authorId: editingAuthor.id
      });
      toast.success("Author updated successfully");
    } else {
      await createAuthor(authorData);
      toast.success("Author created successfully");
    }

    setModalVisible(false);
    loadAuthors();

  } 
  catch (err) {
  const data = err?.response?.data;

  // extract only "details"
  const backendMessage = data?.details || "Something went wrong";

  toast.error(backendMessage);
}

};


  return {
  authors,
  error,
  loading,
  modalVisible,
  editingAuthor,
  form,
  pagination,
  handleSubmit,
  handleEdit,
  handleModalClose,
  handleAddNew,
  handlePageChange
};

};